import React from 'react';

import css from './ForgotPasswordPage.module.css';
import {ForgotPasswordComponent} from "../../components";


const ForgotPasswordPage = () => {

    return (
        <section className={css.wrap}>
            <ForgotPasswordComponent/>
        </section>
    );
};

export {ForgotPasswordPage};